import { makeVar } from '@apollo/client';
import { AgendaItemType } from '@graphql/gql/graphql';

export type MyScheduleFilter = {
  term: string;
  agendaTypes: AgendaItemType[];
  start: string;
  end: string;
};

// This is used to store query criteria for SEARCH_SCHEDULE query in my Schedule
// and is later used to update the appropriate cache
export const myScheduleFilterVar = makeVar<MyScheduleFilter>(null);
